import React from "react";
import TournamentPrizePool from "./TournamentPrizePool/TournamentPrizePool";
import TournamentParticipants from "./TournamentParticipants/TournamentParticipants";
import {useDispatch, useSelector} from "react-redux";
import {closeLobbyModal} from "../../../redux/actions/lobby/actions";
import {formatTimestamp, handleTournamentReBuy} from "../../../utils";
import {useTranslation} from "react-i18next";
import combinedTournamentButtons from "../Buttons/TournamentButtons";
import SafeDynamicComponent from "../SafeDynamicComponent.jsx";

function TournamentInfo() {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {id, isMobile, currency,lang} = useSelector(state => state.user);
    const {list, sideBarTournamentId} = useSelector(state => state.tournament);
    const tournament = list[sideBarTournamentId] || {};
    const tournamentInfo = tournament?.info || {};
    const TournamentStateButton = combinedTournamentButtons[tournamentInfo?.status];
    const participants = tournament?.players || {};
    const playerPoints = participants?.[id]?.points || 0
    let reBuyAmount = handleTournamentReBuy(tournamentInfo, currency, playerPoints)
    if (!sideBarTournamentId) return;
    return (
        <div className="tournament-info">
            <div className="tournament-info--wrapper">
                <div className="tournament-info--header">
                    <p>{t('tournament.information')}</p>
                    {
                        isMobile &&
                        <i className="icon-close"
                           onClick={() => dispatch(closeLobbyModal())}
                        />
                    }
                </div>
                <div className="tournament-info--body">
                    <div className="tournament-info--body__row">
                        <span className="tournament-info--body__row--title">ID</span>
                        {tournamentInfo?.id || '-'}
                    </div>
                    <div className="tournament-info--body__row">
                        <span className="tournament-info--body__row--title">{t('tournament.reg_time')}</span>
                        {tournamentInfo ? formatTimestamp(tournamentInfo?.registrationDate, "monthName-day-time",lang) : '-'}
                    </div>
                    <div className="tournament-info--body__row">
                        <span className="tournament-info--body__row--title">{t('tournament.start_time')}</span>
                        {tournamentInfo ? formatTimestamp(tournamentInfo?.startDate, "monthName-day-time",lang) : '-'}
                    </div>
                    <div className="tournament-info--body__row">
                        <span className="tournament-info--body__row--title">{t('tournament.bet')}</span>
                        {
                            tournamentInfo
                                ?
                                <p>{tournamentInfo?.buyIn?.[currency]}
                                    <span
                                        className="currency-small">{currency}</span></p>
                                : '-'
                        }
                    </div>
                    {
                        tournamentInfo?.hasReBuy && <div className="tournament-info--body__row">
                            <span className="tournament-info--body__row--title">{t('tournament.reBuy')}</span>
                            <p>{tournamentInfo?.reBuyLimit} / {reBuyAmount}
                                <span
                                    className="currency-small">{currency}</span></p>
                        </div>
                    }

                    <div className="tournament-info--body__row">
                        <span className="tournament-info--body__row--title">{t('tournament.round')}</span>
                        {tournamentInfo ? `${tournamentInfo?.round} ${tournamentInfo?.bettingTimer > 0 ? ` / ${tournamentInfo?.bettingTimer}` : ''}` : '-'}
                    </div>
                    <div className="tournament-info--body__row">
                        <span className="tournament-info--body__row--title">{t('tournament.step_time')}</span>
                        {
                            tournamentInfo
                                ?
                                `${tournamentInfo?.stepTime} ${t('tournament.s')} / ${tournamentInfo?.bankTime} ${t('tournament.s')}`
                                :
                                '-'
                        }
                    </div>
                    <div className="tournament-info--body__row">
                        <span className="tournament-info--body__row--title">{t('tournament.participants')}</span>
                        {
                            tournamentInfo
                                ?
                                `${Object.keys(participants)?.length} ( ${tournamentInfo?.minPlayers} / ${tournamentInfo?.maxPlayers} )`
                                :
                                '-'
                        }
                    </div>
                    <div className="tournament-info--body__row">
                        <span className="tournament-info--body__row--title">{t('tournament.convention')}</span>
                        <div>
                            {
                                tournamentInfo?.conventions?.map((item, index) => {
                                    return <i
                                        key={`icon-${item}${index}`}
                                        className={`icon-${item} table-icon`}
                                    />
                                })
                            }
                        </div>
                    </div>
                    <div className="tournament-info--body__row tournament-info--body__row--prize">
                        <span className="tournament-info--body__row--title">{t('tournament.prize_pool')}</span>
                        <TournamentPrizePool
                            prizePool={tournamentInfo?.prizePool}
                            prize={tournamentInfo?.prize?.[currency]}
                            currency={currency}
                        />
                    </div>
                </div>

                {isMobile &&
                    <div className="tournament-info--buttons">
                        <SafeDynamicComponent Component={TournamentStateButton} row={tournament?.rows} desktopRequire={true}/>
                    </div>
                }
                <TournamentParticipants/>
            </div>
        </div>
    )
}

export default TournamentInfo